import { ShaderNSlizgacz } from '../shaders/legs/shader_n_slizgacz';
import { ProductType } from '@/store/modules/product';
import { ShaderNBox } from '../shaders/legs/shader_n_box';
import { ShaderNOkragla } from '../shaders/legs/shader_n_okagla';
import { ShaderNPlozy } from '../shaders/legs/shader_n_plozy';
import { ShaderNStBox } from '../shaders/legs/shader_n_st_box';
import { ShaderNStGiety } from '../shaders/legs/shader_n_st_giety';
import { ShaderNStProsta } from '../shaders/legs/shader_n_st_prosta';
import { ShaderNStPrzesun } from '../shaders/legs/shader_n_st_przesun';
import { ShaderNStScieta } from '../shaders/legs/shader_n_st_scieta';
import { ShaderNStStozek } from '../shaders/legs/shader_n_st_stozek';
import { ShaderNStozek } from '../shaders/legs/shader_n_stozek';
import { ShaderNWalec } from '../shaders/legs/shader_n_walec';
import { Legs } from './legs';

export const bedLegs = [
    new Legs(
        `lozko_{w}_n_slizgacz.gltf`,
        `lozko_n_slizgacz_light.jpg`,
        new ShaderNSlizgacz(),
        0,
        ProductType.BED,
        'l_slizgacz_icon.jpg',
        20,
    ),
    new Legs(
        `lozko_{w}_n_box.gltf`,
        `lozko_n_box_light.jpg`,
        new ShaderNBox(),
        0,
        ProductType.BED,
        'l_noga_prosta_debowa_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_okragla.gltf`,
        `lozko_n_okragla_light.jpg`,
        new ShaderNOkragla(),
        0,
        ProductType.BED,
        'l_noga_metalowa_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_plozy.gltf`,
        `lozko_n_plozy_light.jpg`,
        new ShaderNPlozy(),
        0,
        ProductType.BED,
        'l_ploza_metalowa_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_st_box.gltf`,
        `lozko_n_st_box_light.jpg`,
        new ShaderNStBox(),
        0,
        ProductType.BED,
        'l_stelaz_skosny_drewniany_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_st_giety.gltf`,
        `lozko_n_st_giety_light.jpg`,
        new ShaderNStGiety(),
        0,
        ProductType.BED,
        'l_stelaz_giety_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_st_prosta.gltf`,
        `lozko_n_st_prosta_light.jpg`,
        new ShaderNStProsta(),
        0,
        ProductType.BED,
        'l_stelaz_prosty_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_st_przesun.gltf`,
        `lozko_n_st_przesun_light.jpg`,
        new ShaderNStPrzesun(),
        0,
        ProductType.BED,
        'l_stelaz_skosny_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_st_scieta.gltf`,
        `lozko_n_st_scieta_light.jpg`,
        new ShaderNStScieta(),
        0,
        ProductType.BED,
        'l_stelaz_skosny_debowy_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_st_stozek.gltf`,
        `lozko_n_st_stozek_light.jpg`,
        new ShaderNStStozek(),
        0,
        ProductType.BED,
        'l_stelaz_skosny_drewniany_stozek_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_stozek.gltf`,
        `lozko_n_stozek_light.jpg`,
        new ShaderNStozek(),
        0,
        ProductType.BED,
        'l_noga_stozek_drewniana_icon.jpg',
        200,
    ),
    new Legs(
        `lozko_{w}_n_walec.gltf`,
        `lozko_n_walec_light.jpg`,
        new ShaderNWalec(),
        0,
        ProductType.BED,
        'l_noga_walec_debowa_icon.jpg',
        200,
    ),
];
